import { Text } from '@zillow/constellation';
import styled from 'styled-components';

export const HomeLoansDashboardLinkHeader = styled(Text)`
    font-weight: 700;
    font-size: 14px;
    line-height: 40px;
    font-family: 'Open Sans', Gotham, gotham, Tahoma, Geneva, sans-serif;
`;
